var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('i-col',{attrs:{"span":"24"}},[_c('h1',[_vm._v("Welcome "+_vm._s(_vm.currentUser.name))]),_c('br'),_c('MonthlyFiguresDisastersChart'),_c('MonthlyFiguresConflictChart')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }